import { configureStore } from "@reduxjs/toolkit";
import userReducer from './reducers/user';
import generalSettings from './reducers/settings';
import errorReducer from './reducers/error';
import variablesReducer from './reducers/variables';
import projectReducer from './reducers/project';

export const store = configureStore({
   reducer: { user: userReducer, settings: generalSettings, error: errorReducer, variables: variablesReducer, project: projectReducer }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;